import { useOutletContext } from '@remix-run/react';
import classNames from 'classnames';
import { t } from 'i18next';

import type { OutletContext } from '~/interfaces/outlet_context';

import Logo from '../Logo';
import Typography from '../Typography';

interface Props {
  color?: string;
  className?: string;
}

const PoweredByBeehiiv = ({ color, className }: Props) => {
  const { publicationBeehiivBranding, publicationName } = useOutletContext<OutletContext>();

  if (!publicationBeehiivBranding) return null;

  return (
    <div className="w-fit" color={color}>
      <Typography as="span">
        <a
          target="_blank"
          rel="noreferrer"
          href={`https://www.beehiiv.com/?utm_source=${publicationName}&utm_medium=footer`}
          className={classNames('extra-light flex items-center rounded border px-3 py-2 text-xs', className)}
          style={{
            borderColor: color,
            color,
          }}
        >
          <Logo className="mr-2 h-4 w-4" />
          <Typography as="span" color={color}>
            {t('shared.cta.powered_by_beehiiv') || 'Powered by beehiiv'}
          </Typography>
        </a>
      </Typography>
    </div>
  );
};

export default PoweredByBeehiiv;
